// Conta as buscas em andamento no servidor. O que vem do cache em memória nem
// chega aqui (não chama o axios), então não mostra carregamento.

// Chamadas de fundo e buscas enquanto a pessoa digita: não podem desfocar a tela
const FUNDO = /\/(notifications?|collaborator\/(presenca|online|entrega-avisos|me)|publication\/counts|controladoria|health|ai\/)|\/(search|busca)(\/|\?|$)/i
const PARAMS_DE_BUSCA = ['search', 'q', 'busca', 'NProcesso', 'PartePROPrincipalNome', 'ParteCONPrincipalNome']

// O que muda toda hora, ou que tem hora para vencer, sempre vem do servidor
const SEMPRE_NOVO = /\/(publication|prazos|escavador)(\/|\?|$)/i
const VALIDADE_MS = 3 * 60 * 1000
const MAXIMO = 80

// Cache das telas: voltar a uma tela em até 3 minutos abre na hora, sem carregamento.
// Qualquer gravação, F5 ou aviso em tempo real limpa tudo (ver limparCacheGet).
const guardados = new Map()
let cacheLigado = process.env.NODE_ENV !== 'test'
export const ligarCacheGet = (valor) => { cacheLigado = valor }
export const limparCacheGet = () => guardados.clear()

const copia = (dado) => (dado && typeof dado === 'object' ? JSON.parse(JSON.stringify(dado)) : dado)
const tokenAtual = () => {
  try { return JSON.parse(localStorage.getItem('user') || '{}')?.token || '' } catch { return '' }
}
const chaveDe = (config) => `${tokenAtual()}|${config.baseURL || ''}${config.url || ''}|${JSON.stringify(config.params || {})}`
const podeGuardar = (config) => cacheLigado && !config.semCache && !config.responseType
  && contaComoCarregamento(config) && !SEMPRE_NOVO.test(`${config.baseURL || ''}${config.url || ''}`)

let emAndamento = 0
const ouvintes = new Set()
const avisar = () => ouvintes.forEach((f) => f(emAndamento))

export const assinarCarregamento = (ouvinte) => {
  ouvintes.add(ouvinte)
  return () => ouvintes.delete(ouvinte)
}

export const contaComoCarregamento = (config = {}) => {
  if (config.silencioso) return false
  if (String(config.method || 'get').toLowerCase() !== 'get') return false
  if (FUNDO.test(`${config.baseURL || ''}${config.url || ''}`)) return false
  const params = config.params || {}
  return !PARAMS_DE_BUSCA.some((p) => params[p])
}

const terminar = (config) => {
  if (!config?.yrmContado) return
  config.yrmContado = false
  emAndamento = Math.max(0, emAndamento - 1)
  avisar()
}

export const observarCarregamento = (client) => {
  client.interceptors.request.use((config) => {
    if (podeGuardar(config)) {
      const salvo = guardados.get(chaveDe(config))
      if (salvo && Date.now() - salvo.em < VALIDADE_MS) {
        config.adapter = async () => ({ data: copia(salvo.data), status: 200, statusText: 'OK', headers: salvo.headers, config, request: {} })
        return config
      }
      config.yrmGuardar = true
    }
    if (contaComoCarregamento(config)) {
      config.yrmContado = true
      emAndamento += 1
      avisar()
    }
    return config
  })
  client.interceptors.response.use(
    (response) => {
      const config = response?.config
      terminar(config)
      if (config?.yrmGuardar && response.status === 200) {
        if (guardados.size >= MAXIMO) guardados.delete(guardados.keys().next().value)
        guardados.set(chaveDe(config), { data: copia(response.data), headers: response.headers, em: Date.now() })
      }
      // Gravou algo: o que estava guardado pode estar desatualizado
      if (config && String(config.method || 'get').toLowerCase() !== 'get') limparCacheGet()
      return response
    },
    (error) => { terminar(error?.config); return Promise.reject(error) },
  )
  return client
}

export const zerarCarregamento = () => { emAndamento = 0; limparCacheGet(); avisar() }
